<template>
    <div>
      <div class="row">
        <div class="col-md-12 mb-2">
            <h4>TAC UNIT</h4>
        </div>

        <div class="col mb-2" v-for="(value, region) in datatotal" :key="'summary-region-'+region">
            <el-card shadow="hover">
                <div>{{ getTitle(region) }}</div>
                <div>{{ value }}</div>
            </el-card>
        </div>

        <div class="col-md-12 mb-3" v-if="false">
            <el-card shadow="hover">
                <el-row :gutter="20">
                    <el-col :span="4" v-for="(value, region) in datatotal" :key="'summary-region-'+region">
                        <el-statistic :title="getTitle(region)">
                            <template #formatter>{{ value }}</template>
                        </el-statistic>
                    </el-col>
                </el-row>
            </el-card>
        </div>

        <div class="row"></div>
        <div class="col-md-3 mb-3" v-for="(data, region) in chartdata" :key="'chart-region-'+region">
            <el-card shadow="hover">
                <div class="mb-1">{{ getTitle(region) }}</div>
                <LineChart :data="data" :height="chartheight" :width="500" />
            </el-card>
        </div>

      </div>
    </div>
  </template>

  <script>
  import Fuel from '@/components/page/Fuel.js'
  import LineChart from '@/components/chart/LineChart.js'
  import { Config, AxiosWithJar, Rainbow } from '@/utility.js'

  export default {
    extends: Fuel,
    components: { LineChart },
    props: {
      intervalDuration: { type: Number, default: 15 },
      autoRequestActive: { type: Boolean, default: true },
    },
    data() {
      return {
        autoRequestInterval: null,
        ownership: 'TAC',
        chartheight: 200,
        chartdata: this.initializeData(),
        datatotal: this.initializeData(0),
      };
    },
    mounted() {
      if (this.autoRequestActive) this.startAutoRequest();
    },
    beforeDestroy() {
      this.stopAutoRequest();
    },
    watch: {
      autoRequestActive(newVal) {
        newVal ? this.startAutoRequest() : this.stopAutoRequest();
      },
      intervalDuration() {
        if (this.autoRequestActive) this.updateInterval();
      },
    },
    methods: {
      initializeData(defaultValue = []) {
        return { all: defaultValue, region1: defaultValue, region2: defaultValue, region3: defaultValue, region4: defaultValue, region5: defaultValue, region6: defaultValue, region7: defaultValue };
      },
      getTitle(region) {
        return region === 'all' ? 'TOTAL UNIT' : `REGION ${region.replace('region', '')}`;
      },
      startAutoRequest() {
        this.fetchDataForAllRegions();
        this.autoRequestInterval = setInterval(this.fetchDataForAllRegions, this.intervalDuration * 1000);
      },
      stopAutoRequest() {
        clearInterval(this.autoRequestInterval);
      },
      updateInterval() {
        this.stopAutoRequest();
        this.startAutoRequest();
      },
      fetchDataForAllRegions() {
        ['all', 'region1', 'region2', 'region3', 'region4', 'region5', 'region6', 'region7'].forEach(region => this.fetchData(region));
      },
      async fetchData(region) {
        try {
          const url = `${Config().apiURL}/v1/stations/growthquantitylatest7weeks?OwnershipType=${this.ownership}&region=${region === 'all' ? '' : region.replace('region', '')}`;
          const response = await AxiosWithJar().get(url);
          const data = response.data.data;
          this.chartdata[region] = this.processChartData(data);
          this.datatotal[region] = this.getLastCumulativeActive(data);
        } catch (error) {
          console.error(error);
        }
      },
      processChartData(data) {
        return this.processBarChart(data, 'Legend', '', 'CumulativeActive', false, 'Label', '', 1, 2, Rainbow, false, false, false, false);
      },
      getLastCumulativeActive(data) {
        return data?.length ? data[data.length - 1].CumulativeActive : '-';
      },
    },
  };
  </script>
